import React from "react";
import { LinkProps as RRLinkProps } from "@reach/router";
import { SxStyleProp } from "theme-ui";
import { Link as LinkBase, LinkProps } from "rebass";

interface Props extends Omit<LinkProps, "css"> {
  sx?: SxStyleProp;
  hover?: boolean;
}

const Anchor: React.FunctionComponent<
  Props | Props & Omit<RRLinkProps<any>, "css">
> = ({ sx, hover = true, ...restProps }) => (
  <LinkBase
    sx={{
      fontSize: 1,
      textDecoration: "none",
      color: "primary",

      "&:hover": hover
        ? {
            textDecoration: "underline",
            color: "border",
          }
        : {},

      ...(sx as any),
    }}
    {...restProps}
  />
);

export default Anchor;
